import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../lib/components/grid";
import { GridColumns } from "./loadouttablesetup";

type LoadoutTableGridProps = {
    fill?: any;
    data: any[];
    loading: boolean;
    gridHeight: number;
    rowRenderer?: (props: any) => React.ReactElement;
    handleRefresh: () => void;
    clearFilters?: string;
    showFilterChips?: boolean;
    handleChange: any;
    totalRowColumns: string[];
    countRowColumns?: string[];
    menuItems: any;
    handleAttachment: (id) => void;
    coldstoreoptions: any[];
    portoptions: any[];
    portoptionslocal: any[];
    shippinglines: any[];
    vesseloptions: any[];
    billtypesData: any[];
    clientsoptions: any[];
    groupedPortOptions: any;
    groupedClientOptions: any;
    tempcodes: any[];
} & WithStyles<typeof styles>;

const styles = (theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
        },
    });

class LoadoutTableGridUnstyled extends React.Component<LoadoutTableGridProps, {}> {
    render() {
        const {
            classes,
            data,
            loading,
            gridHeight,
            rowRenderer,
            handleRefresh,
            clearFilters,
            showFilterChips,
            handleChange,
            totalRowColumns,
            countRowColumns,
            menuItems,
            handleAttachment,
            coldstoreoptions,
            portoptions,
            portoptionslocal,
            shippinglines,
            vesseloptions,
            billtypesData,
            clientsoptions,
            groupedPortOptions,
            groupedClientOptions,
            tempcodes
        } = this.props;

        return (
            <div className={classes.root}>
                <Grid
                    fill
                    data={data}
                    loading={loading}
                    forceHeight={gridHeight}
                    rowRenderer={rowRenderer}
                    GridColumns={(data, filters, columnArrangement, columnsWidth) =>
                        GridColumns(
                            data,
                            filters,
                            columnArrangement,
                            columnsWidth,
                            handleAttachment,
                            coldstoreoptions,
                            portoptions,
                            portoptionslocal,
                            shippinglines,
                            vesseloptions,
                            billtypesData,
                            clientsoptions,
                            groupedPortOptions,
                            groupedClientOptions,
                            tempcodes
                        )
                    }
                    handleRefresh={handleRefresh}
                    clearFilters={clearFilters}
                    showFilterChips={showFilterChips}
                    handleChange={handleChange}
                    totalRowColumns={totalRowColumns}
                    countRowColumns={countRowColumns}
                    menuItems={menuItems}
                />
            </div>
        );
    }
}

export default withStyles(styles)(LoadoutTableGridUnstyled);